/**
 * 获取冷库流量看板数据
 */
import request from "_private/utils/request";

// 商品流入量topN企业
export function fetchCompanyFlowInTopN(params) {
  return request({
    url: "/coldTrace/flowBoard/companyFlowInTopN",
    method: "get",
    headers: { type: "json" },
    params
  });
}
// 商品流出量topN企业
export function fetchCompanyFlowOutTopN(params) {
  return request({
    url: "/coldTrace/flowBoard/companyFlowOutTopN",
    method: "get",
    headers: { type: "json" },
    params
  });
}
// 商品流入量详情
export function fetchGoodsFlowInDetail(params) {
  return request({
    url: "/coldTrace/flowBoard/goodsFlowInDetail",
    method: "get",
    headers: { type: "json" },
    params
  });
}
// 商品流出量详情
export function fetchGoodsFlowOutDetail(params) {
  return request({
    url: "/coldTrace/flowBoard/goodsFlowOutDetail",
    method: "get",
    headers: { type: "json" },
    params
  });
}
// 园区服务企业数量
export function fetchStorageCompanyNum(params) {
  return request({
    url: "/coldTrace/flowBoard/storageCompanyNum",
    method: "get",
    headers: { type: "json" },
    params
  });
}
// 城市流入流出分布
export function fetchCityDistribution(params) {
  return request({
    url: "/coldTrace/flowBoard/cityDistribution",
    method: "get",
    headers: { type: "json" },
    params
  });
}
